import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Loader2, Scale } from "lucide-react";
import { kusurSorgu } from "@/lib/api";

export default function KusurDosyaPanel({ dosyaId }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!dosyaId) return;
        setLoading(true);
        kusurSorgu
            .liste({ dosya_id: dosyaId })
            .then((r) => setItems((r.items || []).slice(0, 3)))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [dosyaId]);

    return (
        <div className="rounded-xl border border-white/10 bg-slate-950/40 p-4 mb-4">
            <div className="flex items-center justify-between gap-2 mb-3">
                <div className="flex items-center gap-2">
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/10 bg-black/20">
                        <Scale className="h-4 w-4 text-[#a31d21]" />
                    </span>
                    <div>
                        <div className="font-medium text-sm text-white">Kusur Sorgulama</div>
                        <div className="text-[10px] text-slate-500">AI delil analizi · PDF rapor</div>
                    </div>
                </div>
                <Link
                    to={`/yeni/kusur-sorgulama?dosya_id=${dosyaId}`}
                    className="inline-flex items-center gap-1 text-xs text-[#a31d21] hover:underline"
                >
                    Yeni analiz <ChevronRight className="h-3 w-3" />
                </Link>
            </div>
            {loading ? (
                <div className="flex items-center gap-2 text-xs text-slate-500 py-2">
                    <Loader2 className="h-3 w-3 animate-spin" /> Yükleniyor…
                </div>
            ) : items.length === 0 ? (
                <p className="text-xs text-slate-500 leading-relaxed">
                    Bu dosyada kusur analizi yok. Tutanak, foto ve beyan yükleyerek başlatın.
                </p>
            ) : (
                <ul className="space-y-2">
                    {items.map((k) => (
                        <li key={k.id} className="flex justify-between gap-2 text-xs border-t border-white/5 pt-2 first:border-0 first:pt-0">
                            <div className="min-w-0">
                                <div className="text-slate-300 truncate">{k.baslik}</div>
                                <div className="text-[10px] text-slate-600 mt-0.5">{k.olusturma_tarihi?.slice(0, 10)}</div>
                            </div>
                            <div className="text-right shrink-0 tabular-nums text-slate-300">
                                %{k.oneri_kusur_a ?? "—"} / %{k.oneri_kusur_b ?? "—"}
                                {k.guven_skoru != null ? (
                                    <div className="text-[10px] text-slate-600">Güven {k.guven_skoru}</div>
                                ) : null}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
